// extracted by mini-css-extract-plugin
module.exports = {"editor":"NewsEditor_editor__1Of_O","dialog":"NewsEditor_dialog___xqgK"};